import SettingsIcon from "@mui/icons-material/Settings";
import React from "react";

import { RestrictedFancyLink } from "~/components/parts/FancyLink";

const ManageCoursesLink = ({ className, href = "/manage-courses.php" }) => {
  return (
    <RestrictedFancyLink
      {...{ className, href }}
      message="Your school needs an active subscription to manage courses"
      onClick={() => {
        sessionStorage.setItem("manageCoursesView", "school");
      }}
    >
      <div className="flex flex-none justify-center transition-transform duration-500 group-hover:rotate-180">
        <SettingsIcon sx={{ fontSize: "18px" }} />
      </div>
      <span>Manage school courses</span>
    </RestrictedFancyLink>
  );
};

export default ManageCoursesLink;
